import { memo, type PropsWithChildren } from 'react';

import { Tooltip, type TooltipVisibleChangeHandler } from '../index.tsx';

interface CopyTooltipLayoutProps extends PropsWithChildren {
  tooltip: string;
  copiedTooltip: string;
  disabled?: boolean;
  feedbackVisible: boolean;
  hintVisible: boolean;
  onHintVisibleChange: TooltipVisibleChangeHandler;
}

export const CopyTooltipLayout = memo(function CopyTooltipLayout({
  children,
  copiedTooltip,
  feedbackVisible,
  hintVisible,
  onHintVisibleChange,
  tooltip,
  disabled,
}: CopyTooltipLayoutProps) {
  return (
    <Tooltip
      tooltip={tooltip}
      trigger='hover'
      placement='top'
      disabled={disabled || feedbackVisible}
      onVisibleChange={onHintVisibleChange}
      visible={hintVisible}>
      <Tooltip tooltip={copiedTooltip} visible={feedbackVisible} delayShow={0} placement='top' disabled={disabled}>
        {children}
      </Tooltip>
    </Tooltip>
  );
});
